"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TendersOverviewCalendar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const OverviewCalendarRow_1 = require("./overview-calendar/OverviewCalendarRow");
const OverviewCalendarTenderTitle_1 = require("./overview-calendar/OverviewCalendarTenderTitle");
const useGetHoursPerWeek_1 = require("./overview-calendar/useGetHoursPerWeek");
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
const UnitRowTitle = (0, styled_1.default)(elements_1.Clickable)({
    display: 'flex',
    gap: constants_1.theme.spacing['1.5'],
    padding: `${constants_1.theme.spacing[1]}px ${constants_1.theme.spacing[2]}px`,
    width: '100%',
});
const RowsWrapper = (0, styled_1.default)('div')({
    flexGrow: 1,
    flexBasis: 0,
    overflow: 'auto',
});
const TendersOverviewCalendar = ({ startDate, endDate, units, controls = null, onClickTender, }) => {
    const [openUnits, setOpenUnits] = (0, react_1.useState)({});
    const [weeks, getHoursPerWeek] = (0, useGetHoursPerWeek_1.useGetHoursPerWeek)(startDate, endDate);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, styles: { width: '100%', height: '100%', background: constants_1.Color.WHITE }, children: [(0, jsx_runtime_1.jsx)(OverviewCalendarRow_1.OverviewCalendarRow, { type: "HEADER", title: controls, weeks: weeks.map((week) => week.number) }), (0, jsx_runtime_1.jsx)(RowsWrapper, { children: units.flatMap((unit) => {
                    const isOpen = !!openUnits[unit.id];
                    const weeklyHoursPerTender = unit.tenders.map((tender) => getHoursPerWeek(tender.vacantShifts, tender));
                    const weeklyHourForUnit = weeklyHoursPerTender.reduce((acc, curr) => {
                        curr.forEach((week, index) => {
                            acc[index] = (acc[index] || 0) + (week ?? 0);
                        });
                        return acc;
                    }, []);
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(OverviewCalendarRow_1.OverviewCalendarRow, { type: "UNIT", title: (0, jsx_runtime_1.jsxs)(UnitRowTitle, { onClick: () => setOpenUnits((curr) => ({ ...curr, [unit.id]: !isOpen })), children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: isOpen ? 'ChevronDownIcon' : 'ChevronRightIcon' }), (0, jsx_runtime_1.jsx)(elements_1.Text, { size: 4, bold: true, children: unit.name })] }), weeks: weeklyHourForUnit }), isOpen &&
                                unit.tenders.map((tender, i) => ((0, jsx_runtime_1.jsx)(OverviewCalendarRow_1.OverviewCalendarRow, { isNested: true, type: "TENDER", title: (0, jsx_runtime_1.jsx)(OverviewCalendarTenderTitle_1.OverviewCalendarTenderTitle, { onClick: onClickTender, ...tender }), weeks: weeklyHoursPerTender[i] }, tender.id)))] }));
                }) })] }));
};
exports.TendersOverviewCalendar = TendersOverviewCalendar;
